module.exports = __webpack_public_path__ + "img/06.a5a09d82.gif";